import type { SVGProps } from 'react';

export function TicketIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.999 4.77148C27.4968 4.77148 30.333 7.60767 30.333 11.1055V12.7363C30.3326 13.49 29.8068 14.0354 29.2383 14.2314C28.3222 14.5475 27.666 15.418 27.666 16.4385C27.6662 17.4589 28.3222 18.3295 29.2383 18.6455C29.8068 18.8415 30.3328 19.3868 30.333 20.1406V21.7715C30.3328 25.2691 27.4967 28.1055 23.999 28.1055H7.99902C4.5017 28.105 1.66619 25.2689 1.66602 21.7715V20.1406C1.66623 19.3869 2.19233 18.8417 2.76074 18.6455C3.67693 18.3296 4.33287 17.459 4.33301 16.4385C4.33301 15.4178 3.67703 14.5474 2.76074 14.2314C2.19234 14.0354 1.66638 13.4899 1.66602 12.7363V11.1055C1.66602 7.60794 4.50159 4.77192 7.99902 4.77148H23.999Z"
        fill="url(#paint0_linear_1043_20399)"
      />
      <path
        d="M15.4674 11.8099C15.7341 11.4567 16.2646 11.4567 16.5313 11.8099L17.8519 13.5585C17.9317 13.6641 18.0411 13.7436 18.1662 13.7868L20.2373 14.5024C20.6556 14.647 20.8196 15.1515 20.5661 15.5143L19.3112 17.3107C19.2354 17.4192 19.1936 17.5478 19.1911 17.6801L19.1506 19.871C19.1424 20.3135 18.7132 20.6253 18.2898 20.4964L16.1936 19.858C16.067 19.8194 15.9317 19.8194 15.8051 19.858L13.7089 20.4964C13.2855 20.6253 12.8563 20.3135 12.8481 19.871L12.8076 17.6801C12.8051 17.5478 12.7633 17.4192 12.6875 17.3107L11.4326 15.5143C11.1791 15.1515 11.3431 14.647 11.7614 14.5024L13.8325 13.7868C13.9576 13.7436 14.067 13.6641 14.1468 13.5585L15.4674 11.8099Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1043_20399"
          x1="15.9993"
          y1="4.77148"
          x2="15.9993"
          y2="28.1058"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#839DEB" />
          <stop offset="1" stopColor="#9BB2F6" />
        </linearGradient>
      </defs>
    </svg>
  );
}
